import { createI18n } from 'vue-i18n';

import pl from '@/i18n/pl.json';
import en from '@/i18n/en.json';

type MessageSchema = typeof pl;

export const i18n = createI18n<[MessageSchema], 'pl' | 'en'>({
	legacy: false, // Needs to use with Composition API
	locale: 'pl',  // default language
	fallbackLocale: 'en', // Second language
	globalInjection: true,
	messages: {
		en,
		pl
	}
});
